import React from 'react';
import { FileIcon } from '../FileIcon';
import { ImageIcon } from '../ImageIcon';
import { PdfIcon } from '../PdfIcon';

import { Container } from './index.styled';

type FileTypeIconProps = {
  mimeType: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

const iconMap = {
  'application/pdf': <PdfIcon />,
  'image/jpeg': <ImageIcon />,
  'image/png': <ImageIcon />,
  default: <FileIcon />,
};

const FileTypeIcon: React.FC<FileTypeIconProps> = ({ mimeType, onClick }) => {
  return (
    <Container onClick={onClick}>
      {(iconMap as any)[mimeType] || iconMap.default}
    </Container>
  );
};

export default FileTypeIcon;
